module.exports = __webpack_public_path__ + "media/img/app-store-c21aea78923210afa34f37db3a7eadc9.svg";